module.exports = __webpack_public_path__ + "media/images/img_search02-3473fdcd26e72d584257a3cecbdaaa85.png";